import { render, staticRenderFns } from "./DeleteImages.vue?vue&type=template&id=a7515b4e&lang=html&"
import script from "./DeleteImages.vue?vue&type=script&lang=js&"
export * from "./DeleteImages.vue?vue&type=script&lang=js&"
import style0 from "./DeleteImages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports